import {Button, DataStatus} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {isEmpty} from 'ramda';

import {useListWarrantyProgramQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {openWarrantyProgramFormDialog} from '../utils/openWarrantyProgramFormDialog';
import {WarrantyProgramCard} from './WarrantyProgramCard';

export function WarrantyProgramList(props: RequiredTestIdProps) {
  const {data: programs, isLoading, isError} = useListWarrantyProgramQuery();

  const programList = programs ?? [];

  const handleAddProgram = () => openWarrantyProgramFormDialog();

  return (
    <DataStatus
      isLoading={isLoading}
      isError={isError}
      isEmpty={isEmpty(programList)}
      emptyMessage={i18n.t('entity.warranty.labels.noProgramYet')}
      action={{
        title: i18n.t('entity.warranty.actions.addProgram'),
        leftIcon: 'content/add_circle',
        variant: 'link',
        onClick: handleAddProgram,
      }}
      minHeight={40}
      data-testid={suffixTestId('programs', props)}
    >
      <VStack spacing={4}>
        {programList.map((program, index) => (
          <WarrantyProgramCard
            key={program.id}
            program={program}
            data-testid={suffixTestId(`program-[${index}]`, props)}
          />
        ))}

        <Box>
          <Button
            variant="link"
            leftIcon="content/add_circle"
            title={i18n.t('entity.warranty.actions.addProgram')}
            onClick={handleAddProgram}
            data-testid={suffixTestId('addProgram', props)}
          />
        </Box>
      </VStack>
    </DataStatus>
  );
}
